export const SPANISH = {
  link: {
    login: "/login",
    register: "/register",
    about: "/about",
    search: "/search",
    contact: "/contact",
    website: "/website",
    categories: "/categories",
    categorySelected: "/categories/:name",
    offers: "/offers",
    legal: "/legal",
    terms: "/terms_of_use",
    privacy: "/privacy",
    faq: "/faq",
    orderSummary: "/order_summary",
    payementConfirmation: "/payment_confirmation",
    payementCancel: "/payment_error",

    account: "/my_account",
    addCompany: "/my_account/add_company",

    manageCompany: "/my_account/manage_company/:id/",
    updateCompany: "/my_account/manage_company/:id/update",
    addWebsite: "/my_account/manage_company/:id/add_website",
    selectOffer: "/my_account/manage_company/:id/select_offers",
    manageOffer: "/my_account/manage_company/:id/manage_offers",

    manageWebsite: "/my_account/manage_website/:id/",
    updateWebsite: "/my_account/manage_website/:id/update",

    addPages: "/my_account/manage_website/:id/add_page",
    updatePage: "/my_account/manage_website/:id/update_page/:pageId/",

    admin: "/admin",
  },

  header: {
    home: "Inicio",
    categories: "Categorias",
    about: "Sobre nosotros",
    offers: "Ofertas",
    dashboard: "Espacio usuario",
    connection: "Connectar",
    join: "Registro",
  },

  home: {
    banner: {
      title: "Ayudamos a sus empresas a tener mayor visibilidad en línea y a estar conectadas",
      subtitle: "Registra sus empresas para mejorar su visibilidad en la web",
    },
  },

  highLighted: {
    title: { strong: "Sitios web", text: "destacados" },
  },

  joinedBusiness: {
    title: { text: "Últimos", strong: "sitios" },
  },

  sectionCategories: {
    title: { text: "Categorias de los", strong: "sitios web" },
  },

  sectionWhy: {
    title: { text: "¿Por qué", strong: "unirse a 1 Top Search?" },
    img: {
      view: "Aumento de las vistas",
      seo: "Aumento del SEO",
      joined: "Sitios web registrados",
    },
  },

  sectionOffer: {
    title: { text: "Nuestras", strong: "ofertas" },
  },

  search: {
    title: { text: "Buscar cualquier tipo de", strong: "sitio web" },
    labelCompany: "EMPRESA",
    labelCategory: "CATEGORÍA",
    labelWhere: "DONDE",
    allCategories: "Todas las categorías",
    noResult: "No encontramos ningún sitio web para su búsqueda...",
  },

  categories: {
    categoriesList: { single: "Categoría", multiple: "Categorías" },
    lastWebsites: { text: "Últimos", strong: "sitios web" },
    JoinUsBlock: {
      title: "¿Todavía no está registrado? ¡Únase a nosotros!",
      subtitle: "Registra su empresa y su sitio web para aumentar su visibilidad en línea.",
    },
    noResult: "No hemos encontrado ningún sitio web para esta categoría.",
  },

  login: {
    title: "Connexión",
    subtitle:
      "Esta cuenta es personal y privada y le permite gestionar directamente su cuenta, sus empresas y sus sitios.",
  },

  register: {
    title: "Registro",
    subtitle: "Crear su cuenta y gestionar sus empresas y sitios.",
    alreadyMember: "¿Ya es miembro?",
  },

  account: {
    title: "Mi cuenta",
    companies: {
      total: { single: " Empresa", multiple: " Empresas" },
      btns: {
        manage: "Gestión de mi cuenta",
        add: "Añadir una empresa",
      },
      noCompanies: "Ninguna empresa añadida",
    },

    manageAccount: {
      title: "Gestión de mi cuenta",
      name: "Nombre : ",
      email: "Correo electrónico : ",
      role: "Papel : ",
      btns: {
        edit: "Editar",
      },
    },

    helps: {
      title: "¿Necesitas ayuda?",
      text: "¿Tienes problemas con tu cuenta? Necesitas ayuda ? Contacta con nosotros.",
    },
  },

  footer: {
    legal: "Aviso legal",
    terms: "Terminos y condiciones",
    privacy: "Privacidad",
    faq: "Preguntas frecuentes",
  },

  pageLoader: "La página está cargando... Por favor, espera un momento",

  websiteCard: {
    new: "Nuevo",
    top: "Top",
    websiteOfTheDay: "Sitio del día",
  },

  categoryCard: {
    site: "Sitio",
    sites: "Sitios",
  },

  helperBoxes: {
    why: "¿Por qué unirse a 1 Top Search?",
    about: "Sobre 1 Top Search",
    question: "¿Algunas preguntas? ¡Contacta con nosotros!",
  },

  searchPage: {
    noResult: "No hemos encontrado ningún sitio web para su búsqueda...",
    result: "Resultados para",
    all: { text: "Todos los", strong: "sitios web" },
    btnAdd: "Añadir un sitio",
    found: "profesionales encontrados",
  },

  seeAlso: {
    noResult: "No hay ningún otro sitio web de la misma categoría",
  },

  contactPage: {
    title: "Contacto",
    subtitle: "Puede enviarnos cualquier solicitud aquí. Escriba su mensaje a continuación",
    thanks: "Gracias por su mensaje",
    getBack: "Nos pondremos en contacto con usted cuanto antes",
  },

  placeHolder: {
    email: "Correo electrónico",
    firstName: "Nombre",
    lastName: "Apellido",
    subject: "Objecto",
    message: "Mensaje...",
    password: "Contraseña",
    newPassword: "Nueva contraseña",
    confirmPassword: "Confirmar contraseña",
    country: "País - ej: France",
    city: "Ciudad - ej: Paris",
    street: "Carrer - ej: 1 bis chemin du prevert.",
    codePost: "Código postal - ej: 75001",
    companyName: "Nombre de la empresa - ej: Google",
    companyCode: "Código de la empresa - ej: 877554",
    taxeNumber: "Número de IVA - ej:  12345678A",
    websiteName: "Nombre del sitio - ej: Google", // new
    host: "Alojamiento - ej: google.com", // new
    description: "Descripción...", // new,
    pageName: "Nombre de la página - ej: About", // new
    path: "Enlace - ej: www.myWebsite.com/about", // new
    selectCategories: "Selectionar categorias",
    selectLang: "Selectianar idioma",
    searchName: "ej: Google",
    searchCategory: "ej: Agencia web",
    searchWhere: "ej: Londres",
    userEmail: "Email usuario",
  },

  editInfo: {
    title: "Editar info",
    succes: "¡Perfecto!",
  },

  forgotPassword: {
    title: "Contraseña olvidada",
    subtitle: "Introduzca aquí su correo electrónico",
    sent: "Un correo se ha enviado",
    checkYourMail: "Por favor, compruebe su buzón de correo",
  },

  manageCompany: {
    title: "Gestionar empresas",
    Company: "Empresa",
    address: "Dirección",
    companyCode: "Código de la empresa",
    vat: "Número de IVA",
    companyWebsite: "Sitios web",
    noWebsite: "No sitio añadido",
    addWebsite: "Añadir un sitio",
    status: "Estatus",

    companyPacks: {
      title: "Pack Empresa",
      offerStart: "Inicio de la oferta",
      offerEnd: "Fin de la oferta",
      totalWebsites: "Total de sitios web",
      totalPages: "Total de páginas",
    },
  },

  manageWebsite: {
    title: "Gestionar sitios web",
    websitePages: "Páginas",
    noPages: "No página añadida",
    lang: "Idioma",
    addPage: "Añadir página",
    description: "Descripción",
  },

  addCompany: {
    title: "Añadir una empresa",
    subtitle: "Por favor, rellene todos los campos siguientes para añadir una nueva empresa",
    logoPreview: "Vista previa del logotipo",
    addLogo: "Añadir el logotipo:",
    btnAdd: "Añadir una empresa",
  },

  addWebsite: {
    title: "Añadir sitio web",
    subtitle: "Por favor, rellene todos los campos siguientes",
    category: "Seleccione una categoría",
    language: "Seleccione una idioma",
    addImage: "Añadir una imagen:",
    imagePreview: "Vista previa",
  }, // new

  addPage: {
    title: "Añadir página",
    subtitle: "Rellene todos los campos siguientes para añadir una nueva empresa",
    addImage: "Añadir una imagen:",
    imagePreview: "Vista previa",
  }, // new

  updateCompany: {
    title: "Editar empresa",
    subtitle: "Edite los campos siguientes.",
  }, // new

  updateWebsite: {
    title: "Editar sitio web",
    subtitle: "Edite los campos siguientes.",
  },

  updatePage: {
    title: "Editar página",
    subtitle: "Edite los campos siguientes.",
  },

  resetPassword: {
    title: "Restablecer contraseña",
    subtitle: "Por favor, introduzca su nueva contraseña y confirme.",
  },

  error: {
    general: "Algo salió mal. Inténtalo de nuevo.",
    missingField: "Rellene todos los campos por favor.",
    passwordOrEmail: "Contraseña o correo incorrecto.",
    invalidEmail: "Correo electrónico no válido.",
    passwordConfirmation: "Contraseñas diferentes",
    emailAlreadyRegistered: "Correo ya usado",
    userNotFound: "Usuario no encontrado.", //new
    websiteCredit: "Lo sentimos, no puedes añadir más sitios web con la oferta actual.",
    pageCredit:
      "Lo sentimos, no puedes añadir más páginas web con la oferta actual. Puedes manejar las ofertas para seguir.",
    userAlreadyAdded: "Usuario ya creado.",
  },

  btn: {
    reset: "Cancelar",
    login: "Conectarse",
    signUp: "Registrar",
    forgotPassword: "Olvidé mi contraseña",
    logOut: "Desconectar",
    register: "Registrar",
    viewAll: "Ver más",
    learnMore: "Más información",
    search: "Buscar",
    registerMyBusiness: "Registrar mi empresa",
    registerNow: "Registrar ahora",
    notMember: "¿Aún no es miembro?",
    update: "Actualizar",
    cancel: "Cancelar",
    send: "Enviar",
    back: "Volver",
    delete: "Borrar",
    edit: "Editar",
    contactUs: "Contactar",
    about: "Sobre nosotros",
    visitWebsite: "Ver el sitio",
    visit: "Visitar",
    close: "Cerrar",
    confirm: "Confirmar",
    seeAllCategories: "Ver todas las categorías",
    addWebsite: "Añadir un sitio web",
    addPage: "Añadir una página",
    addCompany: "Añadir una empresa",
    selectOffer: "Seleccionar la oferta",
    manageOffer: "Gestionar las ofertas",
    invoice: "Ver facturas",
    deactivate: "Desactivar",
    addOffer: "Añadir oferta",
    unsuscribe: "Darse de baja",
    activate: "Activar",
    seeMore: "Ver más",
    addUser: "Añadir usuario",
  },

  personalizedOffer: {
    plan: "Oferta personalizada",
    title: "SELECCIONE UNA OPCIÓN",
    first: "por sitio web durante 1 año",
    second: "por 10 páginas más durante 1 año",
  },

  offerCard: {
    yearly: "Anual",
  },

  orderSummary: {
    title: "Resumen del pedido",
    orderTitle: "Su pedido",
    recapTitle: "Resumen del pedido",
    footer:
      "Condiciones de la oferta : la oferta está disponible por una duración de 1 año para una sola empresa. Todas las opciones adicionales no están incluidas y deben ser añadidas a su cuenta",
    menu: {
      offer: "Oferta / Opciones",
      details: "Detalles",
      quantity: "Quantidad",
      price: "Precio",
    },
    recap: {
      total: "Total",
      tax: "Impuesto incluido",
    },
  },

  paymentConfirmation: {
    title: "¡Su pago ha sido realizado!",
    subtitle: "Ya puede disfrutar de su oferta",
    btn: "Volver a mi cuenta",
  },
  paymentError: {
    title: "Algo salió mal.",
    subtitle: "Inténtalo de nuevo.",
    btn: "Volver a mi cuenta",
  },

  about: {
    first: {
      title: "Sobre 1 Top Search",
      subtitle: "1 Top Search, el directorio de sitios web de profesionales",
      content:
        "<p>Somos un directorio que hace referencia a muchos sitios web profesionales de diferentes sectores. El objetivo de este directorio es doble. Por un lado, permite encontrar una gran cantidad de profesionales en todo tipo de categorías. Gracias a un eficaz buscador, los usuarios pueden encontrar fácilmente lo que buscan. Por otro lado, para los profesionales, ayudamos a que su negocio tenga más visibilidad en la wed. Le proponemos diferentes ofertas, diferentes Packs a suscribir para responder a las necesidades de los profesionales.<br> <br> <br> Además, controlamos toda la información publicada en nuestro directorio para ofrecerle siempre la mejor calidad. Por ello, algunas informaciones (datos de la empresa, url de la página web...) son objeto de control. Trabajamos para moderar la información recibida gracias a herramientas de actuación.<br><br><br> Todo contenido que no sea profesional no debe aparecer en este directorio profesional.<br> <br> <br> El directorio está compuesto por varios sectores de actividad. Puede buscar en nuestra base de datos utilizando el motor de búsqueda interno. Este buscador funciona por palabras clave significativas. Cada palabra clave debe estar separada por al menos dos letras. Nuestra herramienta busca en la lista de palabras clave asociadas a los registros referenciados en 1 Top Search. El resultado proporcionado se muestra en relación con la ordenación elegida, por la fecha de publicación más reciente.<br> <br> <br> Para los profesionales registrados en nuestro sitio web, cuanto más completa sea su tarjeta de visita, más palabras clave se asociarán a ella. Por lo tanto, tendrá un mayor potencial de visibilidad.<br> <br> <br> Puede gestionar directamente sus empresas y sitios web desde su cuenta y su panel de control. Un usuario puede tener varias empresas y una empresa puede tener muchas páginas web. También puede añadir algunas páginas específicas de su sitio web para aumentar su visibilidad y SEO.</p>",
    },
    second: {
      title: "Porqué 1 Top Search ?",
      content:
        "<p>Para todos los profesionales con un sitio web, 1 Top Search es una solución que aumentará su visibilidad en línea. Todos sabemos ya la importancia de estar presente en Internet. Si registra su empresa y su sitio web en nuestro directorio profesional, será más visible en la web, lo que significa que conocerá nuevos clientes potenciales y hará crecer su negocio en línea.<br> <br> <br>Además, el hecho de que su empresa y su página web estén en 1 Top Search aumenta su referenciación natural (SEO) para mejorar su posición en el buscador gracias a las palabras clave. Por lo tanto, si su sitio web está bien posicionado en Google, por ejemplo, gracias a un buen SEO, el tráfico en su sitio web también aumentará y podría conseguir nuevos clientes. Esta es una muy buena oportunidad para su negocio que puede ayudar a que su reputación en línea crezca.<br> <br> <br> Nuestro principal objetivo es ofrecer una mejor visibilidad online a los profesionales de diferentes sectores como la tecnología, el marketing y la comunicación o la hostelería. Mientras tanto, el usuario puede encontrar a los profesionales por tema pero también por país. Como profesional, tienes varios datos que rellenar en tu tarjeta de visita. Cuanta más información tenga sobre su negocio, más visible será en nuestro directorio y en la web en general. Puedes editar tu información en cualquier momento en tu cuenta de usuario.<br> <br> <br> Además, puede elegir la oferta que corresponda a su necesidad. Si tienes varias páginas web y quieres promocionarlas todas, es posible. Tienes diferentes opciones y ofertas que te permiten poner tantas empresas, sitios web y páginas como quieras.En resumen, nuestro directorio está hecho para mejorar tu visibilidad en línea conduciendo más tráfico a tu sitio web y promoviendo tu actividad.</p>",
    },
  },

  breadcrumb: {
    account: "Cuenta",
    manageCompany: "Gestionar empresa",
    manageWebsite: "Gestionar sitio web",
  },

  websiteShow: {
    title: "Sitio web",
    noPage: "Este sitio web aún no ha añadido ninguna página.",
  },

  ManageOfferModal: {
    websiteTitle: "Oups, parece que su oferta actual no le permite añadir un nuevo sitio web",
    pageTitle: "Oups, parece que su oferta actual no le permite añadir una nueva página",
    subtitle: "Puede gestionar la oferta de su empresa para seguir adelante.",
  },

  selectOffer: {
    personalizedOffers: "Ofertas personalizadas",
  },

  companyWebsiteCard: {
    page: "Página",
  },

  manageOffer: {
    title: "Gestión de la oferta",
    title2: "Suscripciones actuales",

    modal: {
      title: "Darse de baja",
      title2: "¿Está seguro?",
      subtitle:
        "Se va a cancelar la suscripción pero la oferta sigue siendo válida durante 1 año y terminará el ",
      subtitle2: "Por favor, espere...",
      wait: "Por favor, espere...",
    },
  },

  status: {
    validated: "Validado",
    pending: "Pendiente",
    pendingFast: "Pendiente rápido",
    denied: "Denegado",
    deactivated: "Desactivado",
    deleted: "Borrado",
    unknow: "Desconocido",
  },

  invoices: {
    title: "Facturas de la empresa",
    chekInvoice: "Ver factura",
    noInvoices: "No se han encontrado facturas",
    date: "Fecha:",
  },

  faq: {
    title: "PREGUNTAS FRECUENTES",
    first: {
      title: "GENERAL",
      content:
        "<p class='faq__bloc-title'>¿Qué es 1 Top Search?</p><br/><p>1 Top Search es un directorio profesional con un doble objetivo. Por un lado, permite a los usuarios encontrar directamente a los profesionales de los distintos sectores de actividad (sanidad, electricidad, construcción, restauración, tecnología, etc.) realizando una búsqueda en nuestro sitio mediante una herramienta de búsqueda de alto rendimiento. Por otro lado, permite a los profesionales de los distintos ámbitos registrar su empresa, así como su sitio web y sus páginas específicas, para ganar visibilidad.</p><br/><br/><p class='faq__bloc-title' >¿Puedo registrarme gratuitamente?<p/><br/><p>Todos los profesionales pueden registrarse gratuitamente creando un espacio de usuario con un nombre, un apellido, una dirección de correo electrónico y una contraseña. Este registro gratuito le permite registrar su empresa, su sitio web y una página web dedicada.</p>",
    },
    second: {
      title: "OFERTA",
      content:
        "<p class='faq__bloc-title'>¿Cuáles son sus ofertas? ¿Cuáles son los beneficios?</p> <br/> <p>Tenemos varias ofertas que le permiten ganar visibilidad según sus necesidades. Cada oferta está vinculada a una empresa y una empresa puede suscribir varias ofertas.<br/><br/> - El Pack Empresa le permite añadir (además del registro gratuito) 1 sitio web y 10 páginas específicas. La ventaja de esta oferta es que le permite aumentar su referenciación en los motores de búsqueda (SEO).<br/><br/>- El Pack Agencia le permite añadir (además del registro gratuito) 10 sitios web y 10 páginas adicionales por sitio web. Esto es ventajoso si usted es una agencia o trabaja con varias empresas que quieren ganar visibilidad en línea. Si quiere añadir un sitio o una página adicional a su oferta, puede hacerlo a través de las opciones personalizadas.</p><br/><br/><p class='faq__bloc-title'>¿Cuánto tiempo es válida la oferta? ¿Hay un periodo de compromiso? ¿Puedo cancelar la oferta en cualquier momento?</p><br/> <p>La oferta es válida por un periodo de un año y se renueva tácitamente si no la rescinde. Puedes cancelar tu suscripción a la oferta en cualquier momento desde tu espacio de usuario. La oferta será válida hasta su fecha de caducidad. La cancelación de su oferta dará lugar a la suspensión de sus sitios y páginas, si procede.</p>",
    },
    third: {
      title: "PAGO",
      content:
        "<p class='faq__bloc-title'>¿Cómo se paga?</p> <br/> <p>Puede pagar con tarjeta de crédito (Visa, Eurocard/Mastercard, American Express) o con Paypal directamente en nuestra página web <a>www.1top-search.com.</a> </p><br/><br/><p class='faq__bloc-title'>¿Es seguro el pago? </p><br/> <p>El pago con tarjeta de crédito es completamente seguro. Los números de su tarjeta se transmiten a nuestro servidor seguro mediante el protocolo de encriptación SSL. Al pagar con tarjeta de crédito, este sistema comprueba automáticamente la validez de los derechos de acceso. Cifra todos nuestros intercambios, garantizando su confidencialidad. Los números de su tarjeta de crédito nunca están en posesión de 1 Top Search, se introducen en el servidor seguro de nuestro banco.</p>",
    },
    fourth: {
      title: "DATOS PERSONALES",
      content:
        "<p class='faq__bloc-title'>¿Porqué crear una cuenta? </p> <br/> <p>Su cuenta le permite: gestionar sus empresas, gestionar su sitio web, gestionar sus páginas web y gestionar sus ofertas y facturas. Toda la información de su cuenta de 1 Top Search se utiliza únicamente para los fines de su relación comercial con 1 Top Search. Esta información nunca se comparte con terceros ni se revende. Puede ser modificado por usted en cualquier momento a través de la gestión del área de su cuenta. También puede eliminarse completamente de nuestra base de datos si lo solicita.</p>",
    },
    fifth: {
      title: "CÓMO CONTACTAR CON NOSOTROS",
      content:
        "<p>Si tiene alguna pregunta, puede ponerse en contacto con nosotros directamente a través del formulario de contacto del sitio web.</p>",
    },
  },

  legal: {
    title: "Aviso legal",
    subtitle: "A continuación encontrará la información legal.",
    bloc: {
      title: {
        first: "INFORMACIÓN LEGAL",
        second: "DERECHOS DE PROPIEDAD INTELECTUAL",
        third: "COOKIES",
      },
      first:
        "<p class='legal__bloc-subtitle'>Editor: </p><p>1 Top Search.</p><p class='legal__bloc-subtitle'> Producción y referencia: </p> <p> Subforce, agencia web en Barcelona.<br/> Sitio web: <a href='http://www.subforce.io' target='_blank'>www.subforce.io</a><br/>Director de publicación : Sr. Antoine Jouve</p><p class='legal__bloc-subtitle'>Alojamiento: </p><p>Amazon Web Services Limited Liability Company (LLC) con oficina central en P.O. Box 81226 Seattle, WA 98108-1226, USA</p><p class='legal__bloc-subtitle'>  Copyright :</p><p></p>Todo este sitio está sujeto a la legislación francesa e internacional sobre derechos de autor y propiedad intelectual. Quedan reservados todos los derechos de reproducción, incluso de los documentos fotográficos. Queda formalmente prohibida la reproducción total o parcial de este sitio en cualquier soporte electrónico sin la autorización expresa del director de la publicación. <p class='legal__bloc-subtitle'> Procesamiento de datos y libertad: </p> El derecho de acceso, modificación, rectificación y supresión de los datos que le conciernen (artículo 34 de la ley 78-17 de 6 de enero de 1978 relativa a la informática, los archivos y las libertades) puede ejercerse dirigiéndose al Director de la Publicación.",

      second:
        "<p>El Sitio y todo su contenido (en particular el nombre de dominio, los logotipos, todos los elementos gráficos, textuales e informáticos del Sitio, incluyendo en particular las estructuras de árbol, los diseños, las presentaciones, las ilustraciones, las fotografías y/o cualquier otro documento) están protegidos por la normativa francesa e internacional relativa a la propiedad intelectual. Todos los derechos reservados copyright © - desde 2022. <br/><br/> En ningún caso la navegación por el Sitio, o las menciones que aparecen en él, pueden interpretarse como la concesión de una licencia de uso o de cualquier derecho de utilización de estos elementos. <br/><br/> Por lo tanto, su representación, reproducción, imbricación, distribución y retransmisión, ya sea en parte o en su totalidad, están prohibidas (artículo L. 122-4 del Código de la Propiedad Intelectual francés). Cualquier persona que lo haga sin poder demostrar la autorización previa y expresa del titular de estos derechos se expone a las sanciones relativas al delito de falsificación (artículos L. 335-2 y siguientes del Código de la Propiedad Intelectual francés). El Editor puede hacer uso de sus derechos, en particular de los derechos de propiedad intelectual, para iniciar un procedimiento judicial, en particular un procedimiento penal.<br/><br/>1 Top Search se reserva el derecho de mejorar o modificar en cualquier momento la información, los productos, los programas o las condiciones de uso descritas en el Sitio, sin que se le pueda imputar responsabilidad alguna por ello. Los términos y condiciones aplicables serán los vigentes en el momento de su conexión al Sitio.</p>",

      third:
        "<p>1 Top Search se reserva el derecho de utilizar cookies para su correcto funcionamiento. Se informa al usuario de que, durante sus visitas al sitio <a href='http://www.1top-search.com' target='_blank'>www.1top-search.com</a>,  pueden instalarse automáticamente una o varias cookies en su software de navegación.</p><br><p>Una cookie es un bloque de datos que no permite identificar a los usuarios, pero que se utiliza para registrar información relativa a la navegación del usuario en el sitio.</p><br><p>La configuración del software de navegación permite al usuario ser informado de la presencia de una cookie y eventualmente rechazarla.</p>",
    },
  },

  security: {
    title: "Privacidad",
    subtitle: "A continuación encontrará nuestra política de privacidad.",
    content:
      "<p>Esta sección está dedicada a nuestra política de privacidad. Le permite saber más sobre el origen y el uso de la información de navegación procesada cuando visita nuestro sitio y sus derechos.<br/><br/>La siguiente información se proporciona para que usted conozca los compromisos de protección de datos personales por parte de 1 Top Search, que actúa como responsable del tratamiento de los datos personales a los que se refiere este documento.<br/><br/><br/><p class='privacy__content-title'>Importancia de proteger su privacidad </p><br/>El tratamiento de los datos personales y los datos recogidos por 1 Top Search no son reutilizados por ninguna tercera empresa ni revendidos.<br/><br/>Nuestra política de privacidad es relevante para cualquier usuario que comparta datos personales directa o indirectamente en el Sitio de cualquier manera. <br/><br/>- El usuario ha creado una cuenta en 1 Top Search (modo activo) declarando su identidad profesional.<br/><br/>- El visitante consulta el sitio 1 Top Search (modo pasivo) para ver la información profesional.<br/><br/><br/><p class='privacy__content-title'>Datos recolectados</p><br/>Toda la información recogida es visible desde los diferentes formularios de creación (cuenta personal, empresa, sitios web, página web).  <br/><br/>Para crear una cuenta de usuario de 1 Top Search, debe proporcionar un nombre, un apellido, una dirección de correo electrónico y una contraseña.<br/><br/>Tras crear su cuenta, tendrá acceso a un espacio privado y personal que le permitirá: gestionar sus empresas, gestionar sus sitios web, gestionar sus páginas web y gestionar sus ofertas y facturas.<br/><br/>Sólo publique los datos personales que acepte hacer públicos.<br/><br/><br/><p class='privacy__content-title'>Conservación des datos</p><br/>Conservamos sus datos personales mientras su cuenta de usuario esté activa, es decir, mientras exista.<br/><br/>Para borrar sus datos, sólo tiene que contactar con nosotros via el formulario de contacto de nuestro sitio. Para modificar o corregir los datos, puede hacerlo usted mismo a través del espacio de usuario 1 Top Search.<br/><br/>Si tiene alguna pregunta sobre la protección de datos, contacte con nosotros.</p>",
  },

  cgv: {
    title: "Terminos y condiciones",
    subtitle: "A continuación encontrará los condiciones generales de venta.",
    content:
      "<p><p class='privacy__content-title'>APPLICACIÓN DE LAS CGV</p>Las presentes condiciones generales de venta son aplicables a los usuarios del sitio <br/><a href='http://www.1top-search.com' target='_blank'>www.1top-search.com.</a><br/><br/>Cualquier uso y pago validado en el sitio implica la adhesión total y completa a estas condiciones generales de venta. <p class='privacy__content-title'>VISTA GENERAL</p>Los siguientes términos “nosotros”, “nuestro” y “nos” se refieren a 1 Top Search. Ofrecemos este sitio web, incluida toda la información, las herramientas y los servicios disponibles en él, a los usuarios que acepten todos los términos y condiciones siguientes.<br/><br>Al visitar este sitio y/o suscribirse a nuestras ofertas, usted está participando en nuestro “Servicio” y acepta estar obligado por los “Terminos y condicions”  incluyendo los términos y condiciones adicionales aquí mencionados. Estas condiciones se aplican a todos los usuarios que navegan por el sitio.<br/><br/>Nos reservamos el derecho de actualizar, modificar o sustituir cualquier parte de estas Condiciones Generales en nuestro sitio web. Es su responsabilidad revisar esta página regularmente para ver si hay cambios. El uso o acceso continuado al sitio web tras la publicación de cualquier cambio constituirá su aceptación de dichos cambios.<p class='privacy__content-title'>CONDITCIONES GENERALES</p>Usted se compromete a no reproducir, duplicar, copiar, vender, revender o explotar cualquier parte del Servicio o el uso del Servicio, o cualquier acceso al Servicio o contacto en el sitio web a través del cual se proporciona el Servicio, sin nuestra previa autorización expresa por escrito.<p class='privacy__content-title'>CAMBIOS DE PRECIO</p>Nos reservamos el derecho de modificar el precio de las ofertas en cualquier momento, sin previo aviso. La oferta se le facturará sobre la base de las tarifas vigentes en el momento de la suscripción de la oferta. La oferta es válida desde el momento en que se acepta el pago.<br/><p class='privacy__content-title'>OFERTAS</p>Todas las descripciones de las ofertas y los precios están sujetos a cambios en cualquier momento sin previo aviso, a nuestra entera discreción.<br/>No garantizamos que la oferta, los servicios o cualquier otra información obtenida o adquirida por usted satisfaga sus expectativas.<br/><p class='privacy__content-title'>EEXACTITUD DE LA INFORMACIÓN DE FACTURACIÓN Y DE LA CUENTA</p>Usted se compromete a proporcionar información de pago y de cuenta actual, completa y válida para todos los pagos realizados. Usted se compromete a actualizar puntualmente la información de su cuenta, incluida su dirección de correo electrónico, los números de las tarjetas de crédito y las fechas de caducidad, para que podamos completar sus transacciones y ponernos en contacto con usted si es necesario.<p class='privacy__content-title'>DURACIÓN DE LA OFERTA</p>La oferta es válida durante un mínimo de 1 año a partir de la fecha de pago.<p class='privacy__content-title'>TERMINACIÓN</p>Las presentes Condiciones Generales estarán en vigor hasta que sean rescindidas. Usted puede rescindir estos Términos y Condiciones en cualquier momento notificándonos que ya no desea utilizar nuestros Servicios, o cuando deje de utilizar nuestro sitio.<br/><br/>La oferta es tácitamente renovable cada año, salvo que se rescinda en cualquier momento y a más tardar en la fecha de vencimiento que figura en la sección « Mi cuenta », en la página « Gestión de las empresas ».<br><br>Cualquier cancelación debe ser notificada a través del botón « Darse de baja » accessible el la sección « Mi cuenta ».<br><br>La cancelación tendrá efecto después de la fecha de caducidad de la oferta actual.<br><br>Nos reservamos el derecho de cancelar y/o suspender el acceso a nuestras ofertas en los siguientes casos: <br>- en caso de impago por parte del Cliente de los pagos debidos en virtud de la oferta.<br>- en caso de que la información comunicada por el usuario en el marco de la suscripción a la oferta sea incompleta, inexacta, inválida u obsoleta.<br><br>Dicha rescisión/suspensión conllevará la desactivación inmediata de la oferta en nuestro sitio web sin derecho a indemnización o reembolso alguno. El usuario será notificado de esta decisión.<p class='privacy__content-title'>TARIFAS Y CONDICIONES DEL PAGO</p>La oferta implica el pago por parte del usuario de un precio fijo anual comunicado al usuario antes de la suscripción de la oferta. Los precios indicados incluyen todos los impuestos al tipo vigente el día de la suscripción.<br><br>Cualquier modificación del precio fijo anual a que se refiere este artículo deberá ponerse en conocimiento del usuario al menos un mes antes de su entrada en vigor. En este caso, el usuario tendrá la opción de cancelar la oferta sin coste alguno, en las condiciones expuestas anteriormente.<br><br>El usuario reconoce y acepta que, al comunicar los datos de su tarjeta bancaria, autoriza a 1 Top Search a realizar un cargo en su tarjeta bancaria cuando se renueve su oferta anualmente.<p class='privacy__content-title'>LEY APPLICABLE</p>Las presentes Condiciones Generales de Venta se rigen y se interpretan de acuerdo con las leyes de Francia.<p class='privacy__content-title'>DISPUTAS</p>La legislación aplicable es la francesa. En caso de litigio, los tribunales franceses serán los únicos competentes.</p>",
  },
  cookies: {
    text: "Utilizamos cookies en nuestro sitio web para ofrecerle una experiencia personalizada y optimizada.",
    btn: "Más información.",
  },

  addUserModal: {
    title: "Añadir usuario a esta empresa",
    label: "Email del usuario",
    confirm: "Usuario añadido correctamente",
    addMore: "Añadir más",
  },

  metadata: {
    home: {
      title: "1 Top Search: el directorio de sitios web de profesionales | 1 Top Search",
      description:
        "1 Top Search: directorio web profesional para mejora la visibilidad de las empresas en línea. Encuentre empresas de diversos sectores con el directorio en línea.",
    },
    categories: {
      title: "Categorías: sectores, áreas profesionales | directorio 1 Top Search",
      description:
        "Busca cualquier tipo de sitio web profesional por categoría. Encuentre sitios web de empresas de diferentes sectores, áreas buscando en el directorio en línea.",
    },
    offers: {
      title: "Ofertas para ganar visibilidad en línea | directory 1 Top Search ",
      description:
        "Ofertas adaptadas a sus necesidades: inscripción gratuita, oferta única o múltiple, ofertas personalizadas para tener una mayor visibilidad en línea en el directorio.",
    },
    about: {
      title: "Sobre 1 Top Search, el directorio web de profesionales | 1 Top Search",
      description:
        "Más información sobre el directorio de empresas en línea. ¿Por qué registrar su empresa en 1 Top Search? ¿Cuáles son las ventajas? ¿Para qué sirve 1 Top Search?",
    },
    aboutWebsite: {
      title: "{#name} - Sobre nosotros: sitios y paginas | directorio 1 Top Search",
    },
    register: {
      title: "Registro: registrar y gestionar sus empresas y sitios | 1 Top Search",
      description:
        "Cree una cuenta, registre tu empresa, sitios y páginas web en el directorio profesional de 1 Top Search. Suscríbase a las ofertas y gestione tu información.",
    },
    login: {
      title: "Conexión: conectarse a su cuenta privada | directorio 1 Top Search",
      description:
        "Conectarse a su cuenta para gestionar sus empresas, sitios web, páginas web, manejar ofertas, cambiar su información personal, cambiar su contraseña...",
    },
    account: {
      title: "Mi cuenta: gestionar, añadir y editar empresas | directorio 1 Top Search",
      description:
        "Gestione su cuenta: edite su información, gestione sus empresas, añada una nueva empresa, añada sitios y páginas web desde su cuenta.",
    },
    contact: {
      title: "Contacto: contactar con nosotros vía el formulario | directorio 1 Top Search",
      description:
        "Contacte con nosotros rellenando el formulario de contacto directamente en nuestro sitio web 1 Top Search. Nuestro equipo está disponible para responder a sus preguntas.",
    },
    faq: {
      title: "Preguntas frecuentes: respondemos a sus preguntas | 1 Top Search",
      description:
        "Respondemos a todas sus preguntas: ¿Para qué sirve 1 Top Search? ¿Por qué registrar su empresa en el directorio en línea? Nuestras ofertas, ventajas, pago...",
    },
    resetPassword: {
      title: "Restablecer su contraseña | Directorio de empresas en línea 1 Top Search",
      description:
        "¿Olvidó su contraseña? Restablece su contraseña y crea una nueva. Introduzca su correo electrónico y haga clic en el enlace recibido para restablecer su contraseña.",
    },
    orderSummary: {
      title: "Resumen de su pedido | Directorio de empresas en línea 1 Top Search",
      description:
        "Encuentre los detalles de su pedido con las ofertas y opciones a las que se ha suscrito, así como la cantidad y el precio. A continuación, confirme su pedido.",
    },
    paymentConfirmation: {
      title: "Confirmación de pago | Directorio de empresas en línea 1 Top Search",
      description:
        "Le confirmamos que su pago se ha realizado con éxito. Ahora puede disfrutar de su oferta y opciones y registrar su empresa, sitios web y páginas en nuestro directorio.",
    },
  },
};
